/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetUserNotificationsCountPathParameters } from 'api/actions/get-user-notifications-count/get-user-notifications-count-path-parameters';
import { GetUserNotificationsCountResponse } from 'api/actions/get-user-notifications-count/get-user-notifications-count-response';

type GetUserNotificationsCountQueryParameters = Record<string, any>;

/**
 * The path of the GetUserNotificationsCount action.
 */
export const getUserNotificationsCountActionPath = new SweetPath<keyof GetUserNotificationsCountPathParameters>(
  '/user/notifications/{type}/count',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetUserNotificationsCount actions.
 */
export default function createGetUserNotificationsCountAction(axios: AxiosInstance) {
  return function getUserNotificationsCountAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetUserNotificationsCountPathParameters;
    query?: GetUserNotificationsCountQueryParameters;
  }) {
    const path = getUserNotificationsCountActionPath.insert(parameters);

    return axios.get<GetUserNotificationsCountResponse, GetUserNotificationsCountResponse>(path, {
      params: query,
      headers,
    });
  };
}
